import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import { LoadingButton } from '@mui/lab';
import { Card, Container, Divider, Link, Stack, Typography } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
// components
import { MHidden } from '../components/@material-extend';
import Logo from '../components/Logo';
import Page from '../components/Page';
import { LoginForm } from '../components/authentication/login';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function Login() {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleSsoLogin = () => {
    navigate('/login-sso'); // Navigate to SsoLogin page
  };
  return (
    <RootStyle title="Login | Peladen Pemda DIY">
      {/* <AuthLayout>
        Don’t have an account? &nbsp;
        <Link underline="none" variant="subtitle2" component={RouterLink} to="/register">
          Get started
        </Link>
      </AuthLayout> */}

      <MHidden width="mdDown">
        <SectionStyle>
          <img
            style={{ width: 400 }}
            src="/static/illustrations/undraw_engineering_team_u99p.svg"
            alt="login"
          />
        </SectionStyle>
      </MHidden>

      <Container maxWidth="sm">
        <ContentStyle>
          <Stack direction="column" spacing={2}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="center"
              component={RouterLink}
              sx={{ color: theme.palette.grey[700], textDecoration: 'none' }}
              to="/"
            >
              <Logo sx={{ width: 75, height: 75 }} />
              <Stack direction="column" p={2}>
                <Typography variant="h4">
                  PELADEN{' '}
                  {['DEVELOPMENT', 'STAGING'].includes(process.env.REACT_APP_STAGE) &&
                    'DEVELOPMENT'}
                </Typography>
                <Typography variant="body2">
                  <b>Pe</b>ngelolaan <b>La</b>yanan A<b>d</b>ministrasi Sist<b>e</b>m Elektro
                  <b>n</b>
                  ik Pemda DIY
                </Typography>
              </Stack>
            </Stack>
            <Divider />
            <Stack sx={{ mb: 5 }}>
              <Typography variant="h4" gutterBottom>
                Sign in
              </Typography>
              <Typography sx={{ color: 'text.secondary' }}>
                Masukkan informasi di bawah ini.
              </Typography>
            </Stack>
            {/* <AuthSocial /> */}

            <LoginForm />

            <LoadingButton
              fullWidth
              size="large"
              type="submit"
              variant="contained"
              onClick={handleSsoLogin}
            >
              Login Using SSO
            </LoadingButton>

            <Typography variant="body2" align="center" sx={{ mt: 3 }}>
              Belum punya akun?&nbsp;
              <Link
                variant="subtitle2"
                style={{ cursor: 'pointer' }}
                onClick={() =>
                  window.open('https://wa.me/6282133576291?text=Hello Diskominfo DIY...', '_blank')
                }
              >
                Hubungi kami
              </Link>
            </Typography>
          </Stack>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
